(() => {
  const selectors = {
    body: 'body',
    slider: '.js--product-slider-main',
    sliderNav: '.js--product-slider-nav',
    sliderImage: '.js--product-slider-nav-image',
    infoHeader: '.js--product-info-item',
    infoWrapper: '.product-info',
    accordionItem: '.product-accordion-ds__item',
    accordionItemContentWrapper: '.product-accordion-ds__item-content-wrapper',
    accordionItemContent: '.product-accordion-ds__item-content-wrapper',
    accordionItemHeader: '.js-product-accordion',
    productRadio: '.js-product-radio',
    productSwitcher: '.product-ds__content-switcher',
    quantityButton: '.js-quanity',
    quanityInput: '.product-form__quantity-input',
    buttonsWrapper: '.product-form__buttons',
    colorSwatcher: '.product-form__swatcher-variants',
    swatchVariant: '.js-color-variant',
    swatcherWrapper: '.product-form__swatcher',
    form: '.product-form',
    formSelect: '.product-form__select',
    swatcherHeaderTitle: '.product-form__swatcher-header-variant',
    productInsideSlider: '.js-product-inside-slider',
    selectOption: '.product-form__select-option',
    shippingCloseButton: '.js-close-shipping-modal',
    shippingModalWrapper: '.product-ds__shipping-modal-wrapper',
    overflowShipping: '.overflow-shipping-wrapper',
    shippingModalOpenButton: '#shipping-modal',
    cartIcon: '.cart-link',
    cartCount: '.cart-link__bubble',
    cartPopUp: '.cart-popup',
    productSlider: '.product-ds__slider',
    templateMultichoise: '.product-ds__wrapper--multichoice',
    productColorVariant: '.product-form__selected-variant-item.product-form__selected-colors-item--selected',
    productColorVariantEmpty: '.product-form__selected-variant-item.product-form__selected-colors-item--empty',
    productColor: '.select-optional-color .product-form__selected-colors',
    modalTrigger: '.product-form__selected-colors-item--empty',
    variantsModalClose: '.close-variant-modal',
    searchToggle: '.product-form__swatcher-header-search',
    searchWrapper: '.product-form__swatcher-header-search-wrapper',
    activeModal: '.product-form__swatcher.active',
    searchButton: '.product-form__swatcher-search-button',
    colorTitle: '.product-form__variant-title',
    addToCartButton: '.product-form__add-to-cart',
    selectedWrapper: '.product-form__select-variant',
    requiredColorWrap: '.select-required-color',
    optionalColorWrap: '.select-optional-color',
    swatchOptional: '.js-optional-color',
    swatchRemove: '.remove-selected.remove-selected-required',
    swatchRemoveOptional: '.remove-selected.remove-selected-optional',
    colorItem: '.product-form__swatcher-variants-item',
    priceOld: '.product-radio__label-content-price .product-radio__label-content-price-old',
    priceOriginal: '.product-radio__label-content-price .product-radio__label-content-price-original',
    optionalItems: '.product-form__select-variant.select-optional-color .product-form__swatcher-variants-item',
    
    searchWrapperActive: 'product-form__swatcher-header-search-wrapper--active',
    bodyModalActive: 'variant-modal-open',
    infoHeaderActiveClass: 'product-info__header-item--active',
    infoContentActiveClass: 'product-info__content-item--active',
    accordionItemActiveClass: 'product-accordion-ds__item--active',
    elementVisibleClass: 'product-element--visible',
    swatchVariantActiveClass: 'product-form__swatcher-variants-item--active',
    shippingModalWrapperActiveClass: 'product-ds__shipping-modal-wrapper--active',
    overflowShippingActiveClass: 'overflow-shipping-wrapper--active',
    bodyOverflowClass: 'body--overflow',
    cartCountVisibleClass: 'cart-link__bubble--visible',
    productSliderActiveClass: 'product-ds__slider--active',
    productRadioActiveClass: 'product-radio__input--active',
    active: 'active',
    selected: 'selected'
  };

  const swatchOptionalColor = document.querySelectorAll(selectors.swatchOptional);
  const selectedVariant = document.querySelector(selectors.productColorVariant);
  const selectedColor = document.querySelector(selectors.productColor);
  const body = document.querySelector(selectors.body);
  const searchButtons = document.querySelectorAll(selectors.searchButton);
  const searchToggles = document.querySelectorAll(selectors.searchToggle);
  const variantsModalClose = document.querySelectorAll(selectors.variantsModalClose);
  const modalTrigger = document.querySelectorAll(selectors.modalTrigger);
  const sliderImage = document.querySelectorAll(selectors.sliderImage);
  const infoHeader = document.querySelectorAll(selectors.infoHeader);
  const accordionItemHeader = document.querySelectorAll(selectors.accordionItemHeader);
  const productRadio = document.querySelectorAll(selectors.productRadio);
  const quantityButton = document.querySelectorAll(selectors.quantityButton);
  const swatchVariant = document.querySelectorAll(selectors.swatchVariant);
  const shippingCloseButton = document.querySelectorAll(selectors.shippingCloseButton);
  const shippingModalOpenButton = document.querySelectorAll(`[href="${selectors.shippingModalOpenButton}"]`);
  const productForm = document.querySelectorAll(selectors.form);

  const sliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: selectors.sliderNav,
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          slidesToShow: 1.08,
          fade: false
        }
      }
    ]
  };

  const sliderNavSettings = {
    slidesToShow: 6,
    slidesToScroll: 6,
    asNavFor: selectors.slider,
    dots: false,
    vertical: true,
    verticalSwiping: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: 'unslick'
      }
    ]
  };

  const swatcherSliderSettings = {
    slidesToShow: 11,
    slidesToScroll: 11,
    arrows: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 8
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6
        }
      },
    ]
  };

  const insideSliderSettings = {
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]
  };

  // slider to slide when click on image
  function slideTo(event) {
    const currentImage = event.target.closest(selectors.sliderImage);
    const currentWrapper = event.target.closest('.product-ds__slider');
    const slider = currentWrapper.querySelector(selectors.slider);

    $(slider).slick('slickGoTo', currentImage.dataset.slickIndex);
  };

  function initSliders() {
    $(selectors.slider).slick(sliderSettings);
    $(selectors.sliderNav).slick(sliderNavSettings);
    $(selectors.productInsideSlider).slick(insideSliderSettings);
  };

  function toggleInfo(event) {
    const currentHeader = event.target.closest(selectors.infoHeader);
    const currentWrapper = event.target.closest(selectors.infoWrapper);

    if (currentHeader.classList.contains(selectors.infoHeaderActiveClass)) {
      return false;
    };

    const currentIndex = currentHeader.dataset.infoIndex;
    const currentInfo = currentWrapper.querySelector(`[data-content-info-index="${currentIndex}"]`);
    const activeHeader = currentWrapper.querySelector(`.${selectors.infoHeaderActiveClass}`);

    if (activeHeader) {
      const activeContent = currentWrapper.querySelector(`.${selectors.infoContentActiveClass}`);

      activeHeader.classList.remove(selectors.infoHeaderActiveClass);
      activeContent?.classList.remove(selectors.infoContentActiveClass);
    };

    currentHeader.classList.add(selectors.infoHeaderActiveClass);
    currentInfo?.classList.add(selectors.infoContentActiveClass);
  };

  function toggleAccordion(event) {
    const curentAccordion = event.target.closest(selectors.accordionItem);
    const currentContent = curentAccordion.querySelector(selectors.accordionItemContent);
    const currentContentWrapper = curentAccordion.querySelector(selectors.accordionItemContentWrapper);

    if (curentAccordion.classList.contains(selectors.accordionItemActiveClass)) {
      curentAccordion.classList.remove(selectors.accordionItemActiveClass);

      if (currentContent) {
        currentContentWrapper.style.height = `0`;
      };
    } else {
      curentAccordion.classList.add(selectors.accordionItemActiveClass);

      if (currentContent) {
        currentContentWrapper.style.height = `${currentContent.scrollHeight}px`;
      };
    };
  };

  function reinitSlider() {
    $(selectors.slider).slick('refresh');
    $(selectors.sliderNav).slick('refresh');
    $(selectors.productInsideSlider).slick('refresh');
  };

  function swapForm(event) {
    const currentProduct = event.target.closest(selectors.productRadio);
    const activeElements = document.querySelectorAll(`.${selectors.elementVisibleClass}`);
    const currentElements = document.querySelectorAll(`[data-belong-product="${currentProduct.value}"]`);
    const currentVariant = document.querySelector(`${selectors.form}[data-belong-product="${currentProduct.value}"] ${selectors.formSelect}`).value;
    const activeRadio = document.querySelector(`.${selectors.productRadioActiveClass}`);

    if (currentProduct.classList.contains(selectors.productRadioActiveClass)) {
      return;
    };

    activeRadio.classList.remove(selectors.productRadioActiveClass);
    currentProduct.classList.add(selectors.productRadioActiveClass);

    activeElements.forEach((element)=> {
      element.classList.remove(selectors.elementVisibleClass);
    });
    currentElements.forEach((element )=> {
      element.classList.add(selectors.elementVisibleClass);
    });

    changeSlider(currentProduct.id);
    reinitSlider();
    updateHistoryState(currentVariant);
  };

  function swapFormFromHistory(id) {
    const currentProduct = document.querySelector(`${selectors.selectOption}[value="${id}"]`).dataset.productId;
    const currentRadio = document.querySelector(`${selectors.productRadio}[value="${currentProduct}"]`);
    const activeElements = document.querySelectorAll(`.${selectors.elementVisibleClass}`);
    const currentElements = document.querySelectorAll(`[data-belong-product="${currentProduct}"]`);
    const currentVariant = document.querySelector(`${selectors.selectOption}[value="${id}"]`);
    const currentVariantColor = document.querySelector(`${selectors.swatchVariant}[data-variant-id="${currentVariant.value}"]`);
    const currentForm = currentVariant.closest(selectors.form);
    const activeVariant = currentForm.querySelector(`.${selectors.swatchVariantActiveClass}`);
    const swatcherHeaderTitle = currentForm.querySelector(selectors.swatcherHeaderTitle);
    const activeRadio = document.querySelector(`.${selectors.productRadioActiveClass}`);

    currentVariant.selected = true;

    if (currentRadio.classList.contains(selectors.productRadioActiveClass)) {
      return;
    };

    activeRadio.classList.remove(selectors.productRadioActiveClass);
    currentRadio.classList.add(selectors.productRadioActiveClass);

    activeElements.forEach((element)=> {
      element.classList.remove(selectors.elementVisibleClass);
    });
    currentElements.forEach((element )=> {
      element.classList.add(selectors.elementVisibleClass);
    });

    activeVariant?.classList.remove(selectors.swatchVariantActiveClass);
    currentVariantColor?.classList.add(selectors.swatchVariantActiveClass);

    if (swatcherHeaderTitle) {
      swatcherHeaderTitle.innerText = currentVariantColor.dataset.variantTitle;
    };

    currentRadio.checked = true;
    if(!document.querySelector(selectors.templateMultichoise)) {
      changeSlider(currentProduct);
    }
  };

  function changeSlider(id) {
    const activeSlider = document.querySelector(`.${selectors.productSliderActiveClass}`);
    const currentSlider = document.querySelector(`${selectors.productSlider}[data-product-slider="${id}"]`);

    if (currentSlider && !currentSlider.classList.contains(selectors.productSliderActiveClass)) {
      currentSlider.classList.add(selectors.productSliderActiveClass);
      activeSlider?.classList.remove(selectors.productSliderActiveClass);
    };
  };

  function updateQuantity(event) {
    event.preventDefault();
    const currentWrapper = event.target.closest(selectors.buttonsWrapper);
    const currentButton = event.target.closest(selectors.quantityButton);
    const quanityInput = currentWrapper.querySelector(selectors.quanityInput);

    if (currentButton.dataset.quantity == 'plus') {
      quanityInput.value = ++quanityInput.value;
    } else if (quanityInput.value !== '1') {
      quanityInput.value = --quanityInput.value;
    };
  };

  function changeVariant(event) {
    const currentVariant = event.target.closest(selectors.swatchVariant);

    if(!currentVariant.classList.contains(selectors.swatchVariantActiveClass)) {
      const currentForm = event.target.closest(selectors.form);
      const activeVariant = currentForm.querySelector(`.${selectors.swatchVariantActiveClass}`);
      const variantSelect = currentForm.querySelector(selectors.formSelect);
      const currentSelectVariant = variantSelect.querySelector(`[value="${currentVariant.dataset.variantId}"]`);
      const swatcherHeaderTitle = currentForm.querySelector(selectors.swatcherHeaderTitle);
      const variantTitle = currentVariant.dataset.variantTitle;
      const variantSlide = document.querySelector(`${selectors.slider} img[alt="${variantTitle}"]`);

      currentVariant.classList.add(selectors.swatchVariantActiveClass);
      currentSelectVariant.selected = true;
      activeVariant?.classList.remove(selectors.swatchVariantActiveClass);

      if(!document.querySelector(selectors.templateMultichoise)) {
        swatcherHeaderTitle.innerText = variantTitle;

        if (variantSlide) {
          $(selectors.slider).slick('slickGoTo', variantSlide.dataset.slickIndex);
        };

        updateHistoryState(currentVariant.dataset.variantId);
      } else {
        applySelectedVariant(currentVariant);
      }

    } else {
      return false;
    };
  };

  function addColor(event) {
    
    const currentVariant = event.target.closest(selectors.swatchOptional);
    document.querySelector(selectors.optionalColorWrap).classList.add(selectors.selected);
    selectedColor.classList.add(selectors.selected);
    const copyCurrentVariant = currentVariant.cloneNode(true);
    copyCurrentVariant.insertAdjacentHTML("beforeend", `<div class="remove-selected remove-selected-optional">    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="white"/>
      <path d="M10 10L22 22M10 22L22 10" stroke="#4F4F4F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg></div> <span class="product-form__selected-colors-badge">-25%</span>`)
    selectedColor.insertAdjacentElement("afterbegin", copyCurrentVariant.cloneNode(true));
    updatePrice();
    closeVariantModal();
  };

  function updatePrice() {
    const priceOldEl = document.querySelector(selectors.priceOld);
    const price = document.querySelector(selectors.priceOriginal);
    let priceOptional = 0;

    document.querySelectorAll(selectors.optionalItems).forEach(item => {
      priceOptional += Number.parseInt(item.dataset.variantPrice)
    })

    const priceOriginal = Number.parseInt(priceOptional) + Number.parseInt(price.dataset.priceOriginal)
    const priceOld = Number.parseInt(priceOptional) + Number.parseInt(priceOldEl.dataset.priceOld)

    price.innerHTML = Shopify.formatMoney(priceOriginal, `${price.dataset.currency}{{amount}}`) 
    priceOldEl.innerHTML = Shopify.formatMoney(priceOld, `${price.dataset.currency}{{amount}}`) 
  }

  function updateHistoryState(variant) {
    if (!history.replaceState || !variant) {
      return;
    }

    const newurl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname +
      '?variant=' +
      variant;
    window.history.replaceState(
      {
        path: newurl
      },
      '',
      newurl
    );
  };

  function closeShippingModal() {
    const body = document.querySelector(selectors.body);
    const overflowShipping = document.querySelector(selectors.overflowShipping);
    const shippingModalWrapper = document.querySelector(selectors.shippingModalWrapper);

    if (shippingModalWrapper) {
      shippingModalWrapper.classList.remove(selectors.shippingModalWrapperActiveClass);
      body.classList.remove(selectors.bodyOverflowClass);
      overflowShipping.classList.remove(selectors.overflowShippingActiveClass);
    };
  };

  function openShippingModal(event) {
    event.preventDefault();
    const body = document.querySelector(selectors.body);
    const overflowShipping = document.querySelector(selectors.overflowShipping);
    const shippingModalWrapper = document.querySelector(selectors.shippingModalWrapper);

    if (shippingModalWrapper) {
      shippingModalWrapper.classList.add(selectors.shippingModalWrapperActiveClass);
      body.classList.add(selectors.bodyOverflowClass);
      overflowShipping.classList.add(selectors.overflowShippingActiveClass);
    };
  };

  function applySelectedVariant(currentVariant) {
    document.querySelector(selectors.requiredColorWrap).classList.add(selectors.selected);
    selectedVariant.classList.add(selectors.selected);
    selectedVariant.insertAdjacentHTML('beforeend', currentVariant.innerHTML);

    closeVariantModal();
    enableAtcButton(true);
  }

  function removeSelectedVariant() {
    const requiredItemWrapper = document.querySelector(selectors.requiredColorWrap);
    requiredItemWrapper.querySelector('.product-form__variant-image-wrap').remove()
    requiredItemWrapper.querySelector('.product-form__variant-title').remove()
    
    document.querySelector(selectors.requiredColorWrap).classList.remove(selectors.selected);
    enableAtcButton(false);
  }

  function removeSelectedOptional(el) {
    el.remove();
    updatePrice();
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest(selectors.swatchRemove)) {
      removeSelectedVariant()
    }
    if (e.target.closest(selectors.swatchRemoveOptional)) {
      removeSelectedOptional(e.target.closest(selectors.swatchOptional))
    }
  }) 

  function enableAtcButton(isEnable) {
    const addToCartBtn = document.querySelector(selectors.addToCartButton);

    isEnable ? addToCartBtn.disabled = false : addToCartBtn.disabled = true;
  }

  function openVariantModal() {
    document.querySelector(`[data-type-color="${this.closest(selectors.selectedWrapper).dataset.typeColor}"].product-form__swatcher`).classList.add(selectors.active);
    body.classList.add(selectors.bodyModalActive)
  }

  function closeVariantModal() {
    document.querySelectorAll('.product-form__swatcher').forEach((item) => {
      item.classList.remove(selectors.active)
    })
    body.classList.remove(selectors.bodyModalActive)
  }

  function togleSearch() {
    this.closest(selectors.swatcherWrapper).querySelector(selectors.searchWrapper).classList.toggle(selectors.searchWrapperActive);
  }

  function searchColor(event) {
    event.preventDefault()
    const searchValue = this.previousElementSibling.value.trim().toLowerCase();

    if (searchValue != '') {
      document.querySelector(selectors.activeModal).querySelectorAll(selectors.colorTitle).forEach((item) => {
        const colorString = item.innerHTML.trim().toLowerCase();

        if (!colorString.includes(searchValue)) {
          item.closest(selectors.colorItem).classList.add('hide')
        }
      })
    } else {
      document.querySelectorAll(selectors.colorItem).forEach((swatch) => {
        swatch.classList.remove('hide')
      })
    }
  }

  async function addToCart(event) {
    event.preventDefault();

    const currentForm = event.target;
    const currentVariantID = currentForm.querySelector(selectors.formSelect).value;
    const currentQuantity = currentForm.querySelector(selectors.quanityInput).value;
    const cartPopUp = document.querySelector(selectors.cartPopUp);
    let formData;

    if(document.querySelector(selectors.templateMultichoise)) {
      const bundle = Math.floor(Math.random() * 90000) + 10000;

      formData = {
        items: [
          {
            id: currentVariantID,
            quantity: currentQuantity,
            properties: {
              _bundle: bundle,
            }
          }
        ],
      };

      document.querySelectorAll('.select-optional-color .js-optional-color').forEach((item) => {
        formData.items.push({
          id: item.dataset.variantId,
          quantity: 1,
          properties: {
            _bundle: bundle,
            _isOptional: 'optional',
          }
        })
      })
    } else {
      formData = {
        items: [
          {
            id: currentVariantID,
            quantity: currentQuantity,
          }
        ],
      };
    }

    const addToCartPromise = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (addToCartPromise && !addToCartPromise.ok) {
      const errorObject = await addToCartPromise.json();

      throw new Error(errorObject.description);
    } else {
      const numberCounts = document.querySelectorAll(selectors.cartCount);

      numberCounts.forEach((count) => {
        count.innerText = +count.innerText + +currentQuantity;
        count.classList.add(selectors.cartCountVisibleClass);
      });

      if (cartPopUp) {
        window.showCartPopup();
      };
    }
  };

  if (window.location.href.indexOf("variant=") > -1) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    swapFormFromHistory(urlParams.get('variant'))
  };

  sliderImage.forEach((image) => {
    image.addEventListener('click', slideTo);
  });

  infoHeader.forEach((info) => {
    info.addEventListener('click', toggleInfo);
  });

  accordionItemHeader.forEach((header) => {
    header.addEventListener('click', toggleAccordion);
  });

  searchToggles.forEach((searchToggle) => {
    searchToggle.addEventListener('click', togleSearch)
  })

  searchButtons.forEach((searchButton) => {
    searchButton.addEventListener('click', searchColor)
  })

  modalTrigger.forEach((color) => {
    color.addEventListener('click', openVariantModal)
  });

  variantsModalClose.forEach((color) => {
    color.addEventListener('click', closeVariantModal)
  });

  productRadio.forEach((radio) => {
    radio.addEventListener('click', swapForm);
  });

  quantityButton.forEach((button) => {
    button.addEventListener('click', updateQuantity);
  });

  swatchVariant.forEach((variant) => {
    variant.addEventListener('click', changeVariant);
  });

  swatchOptionalColor.forEach((color) => {
    color.addEventListener('click', addColor);
  });

  shippingCloseButton.forEach((element) => {
    element.addEventListener('click', closeShippingModal);
  });

  shippingModalOpenButton.forEach((element) => {
    element.addEventListener('click', openShippingModal);
  });

  productForm.forEach((form )=> {
    form.addEventListener('submit', addToCart);
  });

  initSliders();
})();
